<script>
import CasesCommonHeadMobile from "@/components/mobile/案例/CasesCommonHeadMobile.vue";
import NextCaseButtonMobile from "@/components/mobile/案例/NextCaseButtonMobile.vue";

export default {
  name: "MobileHisense",
  components: {NextCaseButtonMobile, CasesCommonHeadMobile}
}
</script>

<template>
  <div class="MobileHisense">
    <CasesCommonHeadMobile :use-pic="false" :videourl="require('@/assets/anime/案例-海信Banner.mp4')" :arrow-url="require('@/assets/anime/案例首页线条-蓝绿色.mp4')">
      <template #headerTitle>工业自动化设备的数字化创新</template>
      <template #headerSlogan>交互设计｜界面设计｜3D渲染</template>
      <template #title1>成果</template>
      <template #content1>通过这样的可视化设计，我们大大简化后厨员工的操作流程，并提高他们的工作效率和准确性；并且减少了培训成本。</template>
      <template #title2>背景</template>
      <template #content2>和利时自动配锅机是一种先进的自动化设备，用于在后厨环境中进配置锅底底料的工作。这种设备具有电气控制屏和订单操作屏，但之前并未做过设计，而本次项目旨在为后厨的员工提供更好的使用体验和操作便利性。</template>
    </CasesCommonHeadMobile>
    <div class="HisenseCustom">
      <div class="PicContainer1">
        <div class="PicContainer1Top">
          <div class="Pic1"></div>
          <div class="Pic2"></div>
        </div>
        <div class="PicContainer1Bottom">
          <div class="Pic3"></div>
        </div>
      </div>
      <div class="MediumText1">
        <div class="Title3">“营造<br>谦逊、广阔的视觉风格”</div>
        <div class="Content3">我们与客户进行了深入的沟通，反复研究了市场趋势、目标受众和品牌识别等关键因素。我们通过持续的努力和探索，将抽象的设计理念"真实、谦逊、广阔"具体化为创造性、简洁的设计解决方案。</div>
      </div>
      <div class="PicContainer2">
        <div class="Pic4" id="pic4"></div>
        <div class="Pic4" id="pic5"></div>
      </div>
      <div class="MediumText2">
        <div class="Title4">“建立<br>便捷式智能化体验”</div>
        <div class="Content4">海信人工智能家居是一款 "基于场景 "的智能家居应用，可满足未来消费市场的更多个性化需求。用户可以自由定义个性化的场景模式。该应用与多个设备智能联动，保持智能控制与真实交互基本一致，降低学习成本，让用户一键享受智能生活。</div>
      </div>
      <div class="PicContainer3">
        <div class="Pic6"></div>
        <div class="Pic7"></div>
      </div>
      <div class="NextContainer">
        <router-link to="/mobileCase/case002"><NextCaseButtonMobile></NextCaseButtonMobile></router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/global.scss" as global;

@mixin flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
@mixin picbox{
  border-radius: 12px;
  background: {
    repeat: no-repeat;
    size: cover;
    position: center;
  };
}
.MobileHisense {
  width: 100vw;
  height: auto;
  .HisenseCustom {
    width: 100%;
    height: auto;
    padding-left: 4%;
    padding-right: 4%;
    margin-bottom: calc(64vw / 3.93);
    .PicContainer1 {
      @include flex;
      width: 100%;
      height: calc(420vw / 3.93);
      margin-top: calc(32vw / 3.93);
      margin-bottom: calc(32vw / 3.93);
      .PicContainer1Top {
        width: 100%;
        height: calc(172vw / 3.93);
        @include flex;
        flex-direction: row;
        .Pic1 {
          width: calc(172vw / 3.93);
          height: 100%;
          @include picbox;
          background-image: url("@/assets/picture/案例/海信/海信01.png");
        }
        .Pic2 {
          width: calc(172vw / 3.93);
          height: 100%;
          @include picbox;
          background-image: url("@/assets/picture/案例/海信/海信02.png");
        }
      }
      .PicContainer1Bottom {
        width: 100%;
        height: calc(233vw / 3.93);
        @include picbox;
        background-image: url("@/assets/picture/案例/海信/海信03.png");
      }
    }
    .MediumText1 {
      @include flex;
      flex-direction: row;
      width: 100%;
      height: auto;
      min-height: calc(112vw / 3.93);
      margin-top: calc(32vw / 3.93);
      margin-bottom: calc(32vw / 3.93);
      .Title3 {
        width: 42%;
        height: 100%;
        color: #4069C3;
        align-self: flex-start;
        @include global.h4-vw-m;
      }
      .Content3 {
        width: 48%;
        height: 100%;
        color: black;
        @include global.content-vw-m;
        line-height: 133.33%;
      }
    }
    .PicContainer2 {
      width: 100%;
      height: calc(482vw / 3.93);
      margin-top: calc(32vw / 3.93);
      margin-bottom: calc(32vw / 3.93);
      @include flex;
      .Pic4 {
        width: 100%;
        height: calc(233vw / 3.93);
        @include picbox;
      }
      #pic4 {
        background-image: url("@/assets/picture/案例/海信/海信04.png");
      }
      #pic5 {
        background-image: url("@/assets/picture/案例/海信/海信05.png");
      }
    }
    .MediumText2 {
      width: 100%;
      min-height: calc(128vw / 3.93);
      margin-top: calc(32vw / 3.93);
      margin-bottom: calc(32vw / 3.93);
      @include flex;
      flex-direction: row;
      .Title4 {
        width: 42%;
        height: 100%;
        color: #4069C3;
        align-self: flex-start;
        @include global.h4-vw-m;
      }
      .Content4 {
        width: 48%;
        height: 100%;
        color: black;
        @include global.content-vw-m;
        line-height: 133.33%;
      }
    }
    .PicContainer3 {
      width: 100%;
      height: calc(316vw / 3.93);
      margin-top: calc(32vw / 3.93);
      margin-bottom: calc(32vw / 3.93);
      @include flex;
      .Pic6 {
        width: 100%;
        height: calc(174vw / 3.93);
        @include picbox;
        background-image: url("@/assets/picture/案例/海信/海信06.png");
      }
      .Pic7 {
        width: 100%;
        height: calc(126vw / 3.93);
        @include picbox;
        background-image: url("@/assets/picture/案例/海信/海信07.png");
      }
    }
    .NextContainer {
      width: 100%;
      height: calc(44vw / 3.93);
      padding-left: 17%;
      padding-right: 17%;
    }
  }
}
</style>